import { ToggleOptions } from '../../models/kt';

export const defaultToggleOptions: ToggleOptions = {
   saveState: false,
};
